import { Injectable } from '@angular/core';

import { NgxUiLoaderService, NgxUiLoaderConfig, SPINNER } from 'ngx-ui-loader';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  showLoader = true;
  public static ngxUiLoaderConfig: NgxUiLoaderConfig = {
  };

  constructor(readonly ngxUiLoaderService: NgxUiLoaderService) {}

  start() {
    if (this.showLoader) {
      this.ngxUiLoaderService.start();
    }
  }

  stop() {
    this.ngxUiLoaderService.stop();
  }
}
